<template>
  <v-autocomplete
    v-model="timezone"
    :items="timezones"
    :filter="filter"
    :disabled="disabled"
    :label="label"
    :dense="dense"
    :hide-details="hideDetails"
    :outlined="!dense"
    :filled="dense"
    :solo="dense"
    :flat="dense"
    :menu-props="menuProps"
    class="timezone-selector-field"
    @change="valueChanged"
  >
    <template v-if="showSelectionTitle" v-slot:selection="{ item }">
      <span :title="selectionTitle(item)">{{ selectionLabel(item) }}</span>
    </template>
  </v-autocomplete>
</template>

<script>

  export default {
    name: 'TimezoneSelector',
    
    data() {
      return {
        timezone: '',
      }
    },
    
    props: {
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      product_name: {
        type: String,
        default: 'edgecaster'
      },
      label: {
        type: String,
        default: 'Timezone'
      },
      dense: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: Boolean,
        default: false
      },
      showSelectionTitle: {
        type: Boolean,
        default: false
      },
    },
    
    watch: {
      value(value) {
        this.timezone = value
      },
      
      timezone() {
        this.$emit('input', this.timezone || '')
      }
    },
    
    mounted() {
      this.timezone = this.value
    },
    
    computed: {
      menuProps() {
        return {
          offsetY: true,
          maxWidth: 360,
        }
      },

      timezones() {
        // convert the list in to text/value object
        var timezones = this.$helpers.getTimezones(this.product_name).map((item) => {
          return {'text': item, 'value': item}
        })
        
        if (this.product_name && this.product_name == 'edgecaster') {
          // hack for edgecaster UTC
          timezones.unshift({'text': 'UTC', 'value': 'UTC'})
        }
        
        return timezones
      },
    },
    
    
    methods: {
      selectionLabel(item) {
        if (!item) {
          return this.timezone || ''
        }
        if (typeof item === 'string') {
          return item
        }
        return item.text || item.value || this.timezone || ''
      },

      selectionTitle(item) {
        return this.selectionLabel(item)
      },

      valueChanged() {
        this.$emit('change', this.timezone)
      },

      filter(item, queryText, itemText) {
        queryText = queryText.toLocaleLowerCase().replace(' ', '_')
        return itemText.toLocaleLowerCase().indexOf(queryText) > -1
      },
    }
  }
</script>